module.exports = __webpack_public_path__ + "assets/img/4_15_big.dfbeb59c.jpg";